// libs
import React, { ReactElement, memo } from "react";
import { Portal, OverflowHidden } from "@swiggy-private/core-ui";

// styles
import { StyledOverlay, MovingTrayContainer, MovingTray } from "./styles/PaymentProgressLoader.styled";

interface PaymentProgressLoaderProps {
    hideMovingTray?: boolean;
}

function PaymentProgressLoader({ hideMovingTray }: PaymentProgressLoaderProps): ReactElement {
    return (
        <Portal>
            <OverflowHidden>
                <>
                    <StyledOverlay visible={true} />
                    {!hideMovingTray && (
                        <MovingTrayContainer>
                            <MovingTray />
                        </MovingTrayContainer>
                    )}
                </>
            </OverflowHidden>
        </Portal>
    );
}

export default memo(PaymentProgressLoader);
